export enum IncentiveLabelTracker {
  SHOW = 'show',
  OPEN = 'open'
}
